import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

import GetNotifications from './_GetNotifications.jsx';

export default class MethodPush extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section className="api-method-landing">
				<h1 className="text--xxl-title l-margin-bottom--xl">Push Notificiation</h1>
				<GetNotifications/>
			</section>
		);
	}
}